import { Checkbox } from '@mui/material';
import { BaseCheckboxProps } from './BaseCheckbox.types';

/**
 * The `BaseCheckbox` control to be wrapped off of by our kiosk controls.
 *
 * @param title - {@link BaseCheckboxProps.title title} description.
 * @param classes - {@link BaseCheckboxProps.classes classes} description.
 * @param checked - {@link BaseCheckboxProps.checked checked} description.
 * @param disabled - {@link BaseCheckboxProps.disabled disabled} description.
 * @param onChange - {@link BaseCheckboxProps.onChange onChange} description.
 * @param icon - {@link BaseCheckboxProps.icon icon} description.
 * @param checkedIcon - {@link BaseCheckboxProps.checkedIcon checkedIcon} description.
 */
export const BaseCheckbox = ({
    title,
    classes,
    checked,
    disabled,
    onChange,
    icon,
    checkedIcon,
}: BaseCheckboxProps) => {
    return (
        <Checkbox
            classes={{
                ...classes,
            }}
            title={title}
            checked={checked}
            aria-checked={checked}
            disabled={disabled}
            aria-disabled={disabled}
            onChange={onChange}
            icon={icon}
            checkedIcon={checkedIcon}
        />
    );
};